import { List, Map } from 'immutable';

import { getInventoryOperationValue } from '../product/getOperationValue';
import { updateVariationsErrors } from '../validations/variations';
import { clearErrors, setErrors } from '../errors';
import { validateShipping } from '../validations/shipping';
import { shouldValidate } from '../product/errors';
import { isValidNumber } from '../number';
import { getSize } from '../iterable/getSize';

import { ERROR, OPERATIONS, SELLING_METHOD, SHIPPING_ERRORS, VALUE } from '../../constants/product';
import { EBAY, ETSY, FAIRE } from '../../constants/channels';
import { COMBINATIONS } from '../../constants/variations';
import { ATTRIBUTE } from '../../constants/attributes';
import { STATUS } from '../../constants/listings';
import { EMPTY } from '../../constants';
import { FORM } from '../../constants/forms';

export function editShipping({ product: source, shopData, ...values }) {
  let product = source;
  let operations = EMPTY.MAP;
  const channel = product.get('channel');

  product = clearErrors({ errors: SHIPPING_ERRORS[channel], path: FORM.SHIPPING, product });

  switch (channel) {
    case EBAY: {
      if (values[ATTRIBUTE.COUNTRY] !== undefined) {
        const value = values[ATTRIBUTE.COUNTRY];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.COUNTRY, VALUE], value);
        operations = operations.set(ATTRIBUTE.COUNTRY, Map({ type: OPERATIONS[EBAY].COUNTRY, value }));
      }

      if (values[ATTRIBUTE.IRREGULAR] !== undefined) {
        const value = values[ATTRIBUTE.IRREGULAR];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.IRREGULAR, VALUE], value);
        operations = operations.set(ATTRIBUTE.IRREGULAR, Map({ type: OPERATIONS[EBAY].IRREGULAR, value }));
      }

      if (values[ATTRIBUTE.LOCATION] !== undefined) {
        const value = values[ATTRIBUTE.LOCATION];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.LOCATION, VALUE], value);
        operations = operations.set(ATTRIBUTE.LOCATION, Map({ type: OPERATIONS[EBAY].LOCATION, value }));
      }

      if (values[ATTRIBUTE.PAYMENT_POLICY] !== undefined) {
        const value = values[ATTRIBUTE.PAYMENT_POLICY];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.PAYMENT_POLICY, VALUE], value);
        operations = operations.set(ATTRIBUTE.PAYMENT_POLICY, Map({ type: OPERATIONS[EBAY].PAYMENT_POLICY, value }));
      }

      if (values[ATTRIBUTE.POSTAL_CODE] !== undefined) {
        const value = values[ATTRIBUTE.POSTAL_CODE];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.POSTAL_CODE, VALUE], value);
        operations = operations.set(ATTRIBUTE.POSTAL_CODE, Map({ type: OPERATIONS[EBAY].POSTAL_CODE, value }));
      }

      if (values[ATTRIBUTE.RETURN_POLICY] !== undefined) {
        const value = values[ATTRIBUTE.RETURN_POLICY];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.RETURN_POLICY, VALUE], value);
        operations = operations.set(ATTRIBUTE.RETURN_POLICY, Map({ type: OPERATIONS[EBAY].RETURN_POLICY, value }));
      }

      if (values[ATTRIBUTE.SHIPPING_POLICY] !== undefined) {
        const value = values[ATTRIBUTE.SHIPPING_POLICY];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.SHIPPING_POLICY, VALUE], value);
        operations = operations.set(ATTRIBUTE.SHIPPING_POLICY,
          Map({ type: OPERATIONS[EBAY].SHIPPING_POLICY, value })
        );

        if (source.getIn([FORM.SHIPPING, ATTRIBUTE.LOCATION, ERROR])) {
          operations = operations.set(ATTRIBUTE.LOCATION,
            Map({
              type: OPERATIONS[EBAY].LOCATION,
              value: product.getIn([FORM.SHIPPING, ATTRIBUTE.LOCATION, VALUE]),
            })
          );
        }

        if (source.getIn([FORM.SHIPPING, ATTRIBUTE.POSTAL_CODE, ERROR])) {
          operations = operations.set(ATTRIBUTE.POSTAL_CODE,
            Map({
              type: OPERATIONS[EBAY].POSTAL_CODE,
              value: product.getIn([FORM.SHIPPING, ATTRIBUTE.POSTAL_CODE, VALUE]),
            })
          );
        }

        if (source.getIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MAJOR, ERROR])) {
          operations = operations.set(ATTRIBUTE.WEIGHT_MAJOR,
            Map({
              type: OPERATIONS[EBAY].WEIGHT_MAJOR,
              value: product.getIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MAJOR, VALUE]),
            })
          );
        }

        if (source.getIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MINOR, ERROR])) {
          operations = operations.set(ATTRIBUTE.WEIGHT_MINOR,
            Map({
              type: OPERATIONS[EBAY].WEIGHT_MINOR,
              value: product.getIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MINOR, VALUE]),
            })
          );
        }
      }

      if (values[ATTRIBUTE.WEIGHT_MAJOR] !== undefined) {
        const value = values[ATTRIBUTE.WEIGHT_MAJOR];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MAJOR, VALUE], value);
        operations = operations.set(ATTRIBUTE.WEIGHT_MAJOR, Map({ type: OPERATIONS[EBAY].WEIGHT_MAJOR, value }));

        if (source.getIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MINOR, ERROR])) {
          operations = operations.set(ATTRIBUTE.WEIGHT_MINOR,
            Map({
              type: OPERATIONS[EBAY].WEIGHT_MINOR,
              value: product.getIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MINOR, VALUE]),
            })
          );
        }
      }

      if (values[ATTRIBUTE.WEIGHT_MINOR] !== undefined) {
        const value = values[ATTRIBUTE.WEIGHT_MINOR];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MINOR, VALUE], value);
        operations = operations.set(ATTRIBUTE.WEIGHT_MINOR, Map({ type: OPERATIONS[EBAY].WEIGHT_MINOR, value }));

        if (source.getIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MAJOR, ERROR])) {
          operations = operations.set(ATTRIBUTE.WEIGHT_MAJOR,
            Map({
              type: OPERATIONS[EBAY].WEIGHT_MAJOR,
              value: product.getIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT_MAJOR, VALUE]),
            })
          );
        }
      }

      if (values[ATTRIBUTE.DEPTH] !== undefined) {
        const value = values[ATTRIBUTE.DEPTH];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.DEPTH, VALUE], value);
        operations = operations.set(ATTRIBUTE.DEPTH, Map({ type: OPERATIONS[EBAY].DEPTH, value }));
      }

      if (values[ATTRIBUTE.LENGTH] !== undefined) {
        const value = values[ATTRIBUTE.LENGTH];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.LENGTH, VALUE], value);
        operations = operations.set(ATTRIBUTE.LENGTH, Map({ type: OPERATIONS[EBAY].LENGTH, value }));
      }

      if (values[ATTRIBUTE.WIDTH] !== undefined) {
        const value = values[ATTRIBUTE.WIDTH];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.WIDTH, VALUE], value);
        operations = operations.set(ATTRIBUTE.WIDTH, Map({ type: OPERATIONS[EBAY].WIDTH, value }));
      }

      break;
    }

    case ETSY: {
      if (values[ATTRIBUTE.PROCESSING_PROFILE] !== undefined) {
        const processingProfile = values[ATTRIBUTE.PROCESSING_PROFILE];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.PROCESSING_PROFILE, VALUE], processingProfile);

        if (getSize(product.getIn([FORM.VARIATIONS, COMBINATIONS])) > 0) {
          const variations = product
            .get(FORM.VARIATIONS)
            .update(COMBINATIONS, function updateCombinations(combinations) {
              function setValue(combination) {
                return combination.set(ATTRIBUTE.PROCESSING_PROFILE, processingProfile);
              }

              return combinations.map(setValue);
            });

          product = product.set(FORM.VARIATIONS, updateVariationsErrors({ channel, shopData, variations }));
        }

        operations = operations.set(ATTRIBUTE.PROCESSING_PROFILE,
          Map({
            type: OPERATIONS[ETSY].PROCESSING_PROFILE,
            value: List([getInventoryOperationValue({ channel, value: processingProfile })]),
          })
        );
      }

      if (values[ATTRIBUTE.PROFILE_ID] !== undefined) {
        const profileId = values[ATTRIBUTE.PROFILE_ID];
        const profileType = values[ATTRIBUTE.PROFILE_TYPE];
        product = product
          .setIn([FORM.SHIPPING, ATTRIBUTE.HEIGHT, VALUE], '')
          .setIn([FORM.SHIPPING, ATTRIBUTE.LENGTH, VALUE], '')
          .setIn([FORM.SHIPPING, ATTRIBUTE.PROFILE_ID, VALUE], profileId)
          .setIn([FORM.SHIPPING, ATTRIBUTE.PROFILE_TYPE, VALUE], profileType)
          .setIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT, VALUE], '')
          .setIn([FORM.SHIPPING, ATTRIBUTE.WIDTH, VALUE], '');

        operations = operations
          .set(ATTRIBUTE.PROFILE_ID, Map({ type: OPERATIONS[ETSY].SHIPPING_PROFILE, value: profileId }))
          .set(ATTRIBUTE.HEIGHT, Map({ type: OPERATIONS[ETSY].HEIGHT, value: '' }))
          .set(ATTRIBUTE.LENGTH, Map({ type: OPERATIONS[ETSY].LENGTH, value: '' }))
          .set(ATTRIBUTE.WEIGHT, Map({ type: OPERATIONS[ETSY].WEIGHT, value: '' }))
          .set(ATTRIBUTE.WIDTH, Map({ type: OPERATIONS[ETSY].WIDTH, value: '' }));
      }

      if (values[ATTRIBUTE.RETURN_POLICY] !== undefined) {
        const value = values[ATTRIBUTE.RETURN_POLICY];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.RETURN_POLICY, VALUE], value);
        operations = operations.set(ATTRIBUTE.RETURN_POLICY, Map({ type: OPERATIONS[ETSY].RETURN_POLICY, value }));
      }

      if (values[ATTRIBUTE.HEIGHT] !== undefined) {
        const value = values[ATTRIBUTE.HEIGHT];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.HEIGHT, VALUE], value);
        operations = operations.set(ATTRIBUTE.HEIGHT, Map({ type: OPERATIONS[ETSY].HEIGHT, value }));
      }

      if (values[ATTRIBUTE.LENGTH] !== undefined) {
        const value = values[ATTRIBUTE.LENGTH];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.LENGTH, VALUE], value);
        operations = operations.set(ATTRIBUTE.LENGTH, Map({ type: OPERATIONS[ETSY].LENGTH, value }));
      }

      if (values[ATTRIBUTE.WEIGHT] !== undefined) {
        const value = values[ATTRIBUTE.WEIGHT];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT, VALUE], value);
        operations = operations.set(ATTRIBUTE.WEIGHT, Map({ type: OPERATIONS[ETSY].WEIGHT, value }));
      }

      if (values[ATTRIBUTE.WIDTH] !== undefined) {
        const value = values[ATTRIBUTE.WIDTH];
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.WIDTH, VALUE], value);
        operations = operations.set(ATTRIBUTE.WIDTH, Map({ type: OPERATIONS[ETSY].WIDTH, value }));
      }

      break;
    }

    case FAIRE: {
      const sellingMethod = values[ATTRIBUTE.SELLING_METHOD];

      if (sellingMethod !== undefined) {
        product = product.setIn([FORM.SHIPPING, ATTRIBUTE.SELLING_METHOD, VALUE], sellingMethod);
      }

      // Send all three operations when selling method is selected to ensure DB is in sync
      switch (sellingMethod) {
        case SELLING_METHOD.SIZE: {
          // "Open sizing" - set per_style_minimum_order_quantity, reset unit_multiplier and minimum_order_quantity
          if (values[ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY] !== undefined) {
            const value = values[ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY];
            product = product.setIn([FORM.SHIPPING, ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY, VALUE], value);

            const perStyleMoq = isValidNumber(value) ? Math.max(parseInt(value), 1) : 1;
            operations = operations.set(ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY,
              Map({
                type: OPERATIONS[FAIRE].PER_STYLE_MINIMUM_ORDER_QUANTITY,
                value: perStyleMoq,
              })
            );
          }

          // Reset unit_multiplier to 1 and minimum_order_quantity to 0
          if (values[ATTRIBUTE.CASE_SIZE] !== undefined) {
            product = product.setIn([FORM.SHIPPING, ATTRIBUTE.CASE_SIZE, VALUE], values[ATTRIBUTE.CASE_SIZE]);
          }
          operations = operations.set(ATTRIBUTE.CASE_SIZE,
            Map({
              type: OPERATIONS[FAIRE].CASE_SIZE,
              value: 1,
            })
          );

          if (values[ATTRIBUTE.MINIMUM_ORDER_QUANTITY] !== undefined) {
            product = product.setIn([FORM.SHIPPING, ATTRIBUTE.MINIMUM_ORDER_QUANTITY, VALUE], values[ATTRIBUTE.MINIMUM_ORDER_QUANTITY]);
          }
          operations = operations.set(ATTRIBUTE.MINIMUM_ORDER_QUANTITY,
            Map({
              type: OPERATIONS[FAIRE].MINIMUM_ORDER_QUANTITY,
              value: 0,
            })
          );

          break;
        }

        case SELLING_METHOD.CASE: {
          // "By the case" - set unit_multiplier (min 2) and minimum_order_quantity, reset per_style_minimum_order_quantity
          if (values[ATTRIBUTE.CASE_SIZE] !== undefined) {
            const value = values[ATTRIBUTE.CASE_SIZE];
            product = product.setIn([FORM.SHIPPING, ATTRIBUTE.CASE_SIZE, VALUE], value);

            const caseSize = isValidNumber(value) ? Math.max(parseInt(value), 2) : 2;
            operations = operations.set(ATTRIBUTE.CASE_SIZE,
              Map({
                type: OPERATIONS[FAIRE].CASE_SIZE,
                value: caseSize,
              })
            );
          }

          if (values[ATTRIBUTE.MINIMUM_ORDER_QUANTITY] !== undefined) {
            const value = values[ATTRIBUTE.MINIMUM_ORDER_QUANTITY];
            product = product.setIn([FORM.SHIPPING, ATTRIBUTE.MINIMUM_ORDER_QUANTITY, VALUE], value);

            const moq = isValidNumber(value) ? Math.max(parseInt(value), 1) : 1;
            operations = operations.set(ATTRIBUTE.MINIMUM_ORDER_QUANTITY,
              Map({
                type: OPERATIONS[FAIRE].MINIMUM_ORDER_QUANTITY,
                value: moq,
              })
            );
          }

          // Reset per_style_minimum_order_quantity to 0
          if (values[ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY] !== undefined) {
            product = product.setIn([FORM.SHIPPING, ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY, VALUE], values[ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY]);
          }
          operations = operations.set(ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY,
            Map({
              type: OPERATIONS[FAIRE].PER_STYLE_MINIMUM_ORDER_QUANTITY,
              value: 0,
            })
          );

          break;
        }

        case SELLING_METHOD.ITEM:
        default: {
          // "By the item" - set unit_multiplier = 1 and minimum_order_quantity, reset per_style_minimum_order_quantity
          // Handle case when sellingMethod is undefined (individual field edits)
          if (sellingMethod === SELLING_METHOD.ITEM) {
            // Explicitly selected "By the item"
            if (values[ATTRIBUTE.CASE_SIZE] !== undefined) {
              product = product.setIn([FORM.SHIPPING, ATTRIBUTE.CASE_SIZE, VALUE], values[ATTRIBUTE.CASE_SIZE]);
            }
            operations = operations.set(ATTRIBUTE.CASE_SIZE,
              Map({
                type: OPERATIONS[FAIRE].CASE_SIZE,
                value: 1,
              })
            );

            if (values[ATTRIBUTE.MINIMUM_ORDER_QUANTITY] !== undefined) {
              const value = values[ATTRIBUTE.MINIMUM_ORDER_QUANTITY];
              product = product.setIn([FORM.SHIPPING, ATTRIBUTE.MINIMUM_ORDER_QUANTITY, VALUE], value);

              const moq = isValidNumber(value) ? Math.max(parseInt(value), 1) : 1;
              operations = operations.set(ATTRIBUTE.MINIMUM_ORDER_QUANTITY,
                Map({
                  type: OPERATIONS[FAIRE].MINIMUM_ORDER_QUANTITY,
                  value: moq,
                })
              );
            }

            // Reset per_style_minimum_order_quantity to 0
            if (values[ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY] !== undefined) {
              product = product.setIn([FORM.SHIPPING, ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY, VALUE], values[ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY]);
            }
            operations = operations.set(ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY,
              Map({
                type: OPERATIONS[FAIRE].PER_STYLE_MINIMUM_ORDER_QUANTITY,
                value: 0,
              })
            );
          } else {
            // No selling method specified - handle individual field edits (existing behavior)
            if (values[ATTRIBUTE.CASE_SIZE] !== undefined) {
              const value = values[ATTRIBUTE.CASE_SIZE];
              product = product.setIn([FORM.SHIPPING, ATTRIBUTE.CASE_SIZE, VALUE], value);
              operations = operations.set(ATTRIBUTE.CASE_SIZE,
                Map({
                  type: OPERATIONS[FAIRE].CASE_SIZE,
                  value: isValidNumber(value) ? parseInt(value) : null,
                })
              );
            }

            if (values[ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY] !== undefined) {
              const value = values[ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY];
              product = product.setIn([FORM.SHIPPING, ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY, VALUE], value);
              operations = operations.set(ATTRIBUTE.PER_STYLE_MINIMUM_ORDER_QUANTITY,
                Map({
                  type: OPERATIONS[FAIRE].PER_STYLE_MINIMUM_ORDER_QUANTITY,
                  value: isValidNumber(value) ? parseInt(value) : null,
                })
              );
            }

            if (values[ATTRIBUTE.MINIMUM_ORDER_QUANTITY] !== undefined) {
              const value = values[ATTRIBUTE.MINIMUM_ORDER_QUANTITY];
              product = product.setIn([FORM.SHIPPING, ATTRIBUTE.MINIMUM_ORDER_QUANTITY, VALUE], value);
              operations = operations.set(ATTRIBUTE.MINIMUM_ORDER_QUANTITY,
                Map({
                  type: OPERATIONS[FAIRE].MINIMUM_ORDER_QUANTITY,
                  value: isValidNumber(value) ? parseInt(value) : null,
                })
              );
            }
          }

          break;
        }
      }

      break;
    }

    default: {
      return { operations: [], product };
    }
  }

  const errors = validateShipping({
    allowEmpty: !shouldValidate({ product, type: FORM.SHIPPING }),
    allowZero: (
      product.get('status') !== STATUS[FAIRE].PUBLISHED &&
      product.get('status') !== STATUS[FAIRE].UNPUBLISHED
    ),
    channel,
    shipping: product.get(FORM.SHIPPING),
    shopData,
  });

  if (getSize(errors)) {
    product = setErrors({ errors, path: FORM.SHIPPING, product });
  }

  function reduceOperations(result, operation, attribute) {
    if (!errors.get(attribute)) {
      result.operations.push(operation);
    }

    return result;
  }

  return operations.reduce(reduceOperations, { product, operations: [] });
}
